<div class="card card-modal">
  <div class="card-header card-header-info">
    <h5 class="card-title ">
      <span><i class="fas fa-rss mrr-5"></i>Aggiornamenti, nuove funzionalità e modifiche a Fastlane</span>
    </h5>
  </div>
  <div class="card-body card-features">
    <mat-dialog-content>
      <dx-accordion #tableAccordion1 [dataSource]="accordionFunzionalita" [collapsible]="true" [multiple]="true"
        [animationDuration]="500" [selectedIndex]="0">
        <div *dxTemplate="let item of 'title'">
          <div class="caption">{{item.title}}</div>
        </div>
        <div *dxTemplate="let elem of 'item'">
          <div *ngIf="elem.id == 1">
            <div class="col-md-12 content-features">
              <div *ngFor="let vu of lastVersion.changes">
                <h6>{{vu?.title}}</h6>
                <div *ngIf="vu?.changeList?.length > 0" class="status {{vu?.changeType}}">
                  {{ getChangeDescriptionType(vu?.changeType) }}
                </div>
                <ul>
                  <li *ngFor="let description of vu?.changeList">
                    <div>{{ description?.description }}
                      <span *ngIf="description?.link">(<a target="_blank" href="{{ description?.link }}">{{
                          description?.title }}</a>)</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="elem.id == 2">
            <div *ngFor="let c of history">
              <h5 class="titleHistory">Versione {{c.version}} del {{c.date}}</h5>
              <br>
              <div class="col-md-12">
                <div *ngFor="let vu of c.changes">
                  <h6>{{vu?.title}}</h6>
                  <div *ngIf="vu?.changeList?.length > 0" class="status {{vu?.changeType}}">
                    {{ getChangeDescriptionType(vu?.changeType) }}</div>
                  <ul>
                    <li *ngFor="let description of vu?.changeList">
                      <div>{{ description?.description }}
                        <span *ngIf="description?.link">(<a target="_blank" href="{{ description?.link }}">{{
                            description?.title }}</a>)</span>
                      </div>
                    </li>
                  </ul>

                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>

      </dx-accordion>

    </mat-dialog-content>
  </div>
  <div class="card-footer">
    <!-- Buttons -->
    <div class="footer-modal">
      <div class="dx-fieldset">
        <dx-check-box [(value)]="checked" [disabled]="disabled" text="Non visualizzare più questo messaggio"
          (click)="valueChanged($event)">
        </dx-check-box>
      </div>
      <button mat-raised-button mat-button mat-dialog-close class="btn btn-info btn-sm float-right" id="annullaButton"
        (click)="valueChanged($event)"><i class="fas fa-times mrr-5"></i>Chiudi</button>
    </div>
  </div>
</div>